<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc" id="toc"><h1>Contents</h1><ol><li id="level1-titlepage"><span href="#/titlepage" title="Link target outside of Sample">Title Page</span></li>
<li id="level1-toc"><a href="#/toc">Contents</a></li>
<li id="level1-front3"><a href="#/front01">Copyright</a></li>
<li id="level1-front4"><a href="#/front02">Dedication</a></li>
<li id="level1-front5"><a href="#/front03">Epigraph</a></li>
<li id="c01"><a href="#/c01">Be Polite but Have a Plan to Kill Everyone You Meet</a>
</li>
<li id="c02"><a href="#/c02">Top of the World</a>
</li>
<li id="c03"><span href="#/c03" title="Link target outside of Sample">Pollice Verso</span>
</li>
<li id="c04"><span href="#/c04" title="Link target outside of Sample">Neutral Drops</span>
</li>
<li id="c05"><span href="#/c05" title="Link target outside of Sample">Unbomb</span>
</li>
<li id="c06"><span href="#/c06" title="Link target outside of Sample">Tattoo</span>
</li>
<li id="c07"><span href="#/c07" title="Link target outside of Sample">Touch</span>
</li>
<li id="c08"><span href="#/c08" title="Link target outside of Sample">Metatarsal</span>
</li>
<li id="c09"><span href="#/c09" title="Link target outside of Sample">Redwoods</span>
</li>
<li id="c10"><span href="#/c10" title="Link target outside of Sample">Safety</span>
</li>
<li id="c11"><span href="#/c11" title="Link target outside of Sample">Resurrecting a Body Half</span>
</li>
<li id="c12"><span href="#/c12" title="Link target outside of Sample">No Doorbell</span>
</li>
<li id="c13"><span href="#/c13" title="Link target outside of Sample">Thirteen Steps</span>
</li>
<li id="c14"><span href="#/c14" title="Link target outside of Sample">Two Things from a Burning House</span>
</li>
<li id="c15"><span href="#/c15" title="Link target outside of Sample">Wyoming Is a Gun in His Waistband</span>
</li>
<li id="level1-back36"><span href="#/back01" title="Link target outside of Sample">Acknowledgments</span></li>
<li id="level1-back37"><span href="#/back02" title="Link target outside of Sample">About the Author</span></li></ol></nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?4831e6d7